























import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import HtmlEditor from '@tinymce/tinymce-vue'

import Artifacts from '@/components/artifacts/Artifacts.tsx'
import Editor from '@/components/artifacts/NewEditor.tsx'
import AuthorizationMixin from '@/routing/AuthorizationMixin'
import { Process } from '../../store/workflow/types'
import { CaseWithMessages } from '@/queries/cases.graphql'

export default mixins(AuthorizationMixin).extend({
  mixins: [AuthorizationMixin],
  components: {
    Artifacts,
    Editor,
    HtmlEditor,
  },
  apollo: {
    pickedCase: {
      query() {
        return CaseWithMessages
      },
      fetchPolicy: 'no-cache',
      variables() {
        return {
          id: this.caseId,
        }
      },
    },
  },
  methods: {
    getCaseTemplates(): any[] {
      let templates = this.$store.getters['letterTemplates/storedObjects']
      if (!this.pickedCase) {
        return templates
      }
      // get genders
      let myGender = this.pickedCase?.me?.gender?.toLowerCase()
      if (myGender == undefined) {
        myGender = this.$store.getters.currentUser?.gender?.toLowerCase()
      }
      const patientGender = this.pickedCase?.patient?.gender?.toLowerCase()
      return templates.filter((t: any) => {
          return (
            t.type?.toLowerCase() === 'letter' &&
            (t.gender_of_writer === null || t.gender_of_writer?.toLowerCase() === myGender) &&
            (t.gender_of_reader === null || t.gender_of_reader?.toLowerCase() === patientGender)
          )
        })
        .map((t: any) => {
          const title: string =
            typeof t.treatment_code === 'string'
              ? `${t.treatment_code.toUpperCase()}: ${t.title}`
              : t.title
          return { ...t, title }
        })
    },
  },
  data() {
    return {
      configUpdate: 1,
    }
  },
  computed: {
    where(): object {
      return { case_id: this.$store.getters.currentCaseId, code: this.code }
    },
    defaults(): object {
      return { ...this.where, sender_id: this.$store.getters.currentUserId, format: 'markdown' }
    },
    treatmentCode(): string | null {
      let cursor: Vue = this

      while (cursor && cursor.$parent) {
        cursor = cursor.$parent

        console.log('examining parent', cursor)

        if (!cursor.$props) {
          console.log('parent has no props')
          continue
        }

        const process: Process | undefined | null = cursor.$props.inProcess
        if (!process) {
          console.log('parent has no process')
          continue
        }

        const match = process.business_key!.match(/^(ipt|ctb|cr|expo|counseling)-treatment$/)
        if (!match) {
          console.log('process does not match')
          continue
        }

        return match[1]
      }
      return null
    },
    templates(): any[] {
      if (this.treatmentCode) {
        return this.getCaseTemplates().filter(t => t.treatment_code === this.treatmentCode)
      } else {
        return this.getCaseTemplates()
      }
    },
    configs(): any {
      const templates = this.templates
      const directionality = this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
      const config = {
        branding: false,
        directionality,
        height: 400,
        language: this.$i18n.locale,
      }
      if (this.isPatient) {
        return {
          ...config,
          menubar: false,
          toolbar: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify',
          statusbar: false,
        }
      } else {
        return {
          ...config,
          plugins: 'template textcolor colorpicker',
          toolbar:
            'undo redo | bold italic | forecolor backcolor | alignleft aligncenter alignright alignjustify',
          templates,
        }
      }
    },
    currentCase(): any {
      return this.$store.getters.currentCase
    },
  },
  created() {
    const letters: any[] = this.$store.getters['letters/filterBy'](this.where)

    // load all letters
    this.$store.dispatch({ type: 'letters/pullObjects', setLoading: false }).then(data => {
      console.debug('loaded letters', data)
      const letters: any[] = this.$store.getters['letters/filterBy'](this.where)
      // create a letter, if none exists. this avoids jumping between the two editors.
      if (letters.length === 0) {
        return this.$store.dispatch({
          type: 'letters/pushObject',
          object: { ...this.defaults },
        })
      }
    })
  },
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  watch: {
    configs(): void {
      // https://michaelnthiessen.com/force-re-render/
      this.configUpdate += 1
    },
    currentCase(): void {
      this.configUpdate += 1
    },
  },
})
